import { Col } from '@/components/ui/col'
export function PosMockupScreenBistro() {
  return (
    <Col className="relative flex h-full w-1/3">
      <div className="flex h-14 flex-shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4">
        <div className="flex items-center gap-4">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-brand-red shadow-sm">
            <div className="h-2.5 w-2.5 rounded-sm bg-white" />
          </div>
          <Col className="">
            <span className="mt-1 text-lg font-bold leading-none tracking-wide text-charcoal-900">
              Dcorp Enterprise POS
            </span>
            <span className="mt-0.5 font-mono text-fs-md text-charcoal-500">Bistro 42 | Store #108</span>
          </Col>
        </div>
        <div className="flex items-center gap-6 font-mono text-xs text-charcoal-600">
          <span className="hidden sm:inline-block">
            Terminal: <strong className="text-charcoal-900">T-04</strong>
          </span>
          <span className="hidden sm:inline-block">
            Server: <strong className="text-charcoal-900">Alex M.</strong>
          </span>
          <span className="pos-time rounded border border-gray-200 bg-gray-100 px-3 py-1.5 text-sm font-bold text-charcoal-900">
            --:--:--
          </span>
        </div>
      </div>

      <div className="relative flex flex-1 overflow-hidden">
        <Col className="flex flex-1 overflow-hidden border-r border-gray-200 bg-gray-50">
          <div className="mock-scroll flex flex-shrink-0 gap-2 overflow-x-auto border-b border-gray-200 bg-white p-3">
            <button
              type="button"
              className="flex-shrink-0 rounded bg-charcoal-900 px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-white"
            >
              Signatures
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-charcoal-900 hover:text-charcoal-900"
            >
              Mains
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-charcoal-900 hover:text-charcoal-900"
            >
              Sides
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-charcoal-900 hover:text-charcoal-900"
            >
              Beverages
            </button>
          </div>

          <div className="mock-scroll grid grid-cols-2 content-start gap-3 overflow-y-auto p-4 lg:grid-cols-3">
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-brand-red hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Truffle Wagyu Burger</span>
              <span className="mt-2 font-mono text-sm font-bold text-brand-red">$24.00</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-brand-red hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Classic Ribeye (8oz)</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-500">$32.00</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-brand-red hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Spicy Chicken Sandwich</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-500">$16.50</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-brand-red hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Sweet Potato Fries</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-500">$6.50</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-brand-red hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Mac & Cheese Bites</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-500">$8.00</span>
            </Col>
          </div>
        </Col>

        <Col className="z-10 flex w-80 flex-shrink-0 bg-white shadow-[-4px_0_15px_-3px_rgba(0,0,0,0.05)] lg:w-96">
          <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 p-4">
            <Col className="">
              <span className="text-xl font-bold text-charcoal-900">Order #1042</span>
              <span className="mt-0.5 font-mono text-fs-md uppercase text-charcoal-500">Table 12</span>
            </Col>
            <span className="rounded-md border border-brand-red/30 bg-red-50 px-2.5 py-1.5 text-fs-sm font-bold uppercase tracking-widest text-brand-red">
              DINE-IN
            </span>
          </div>

          <Col className="mock-scroll flex flex-1 gap-5 overflow-y-auto p-4">
            <div className="group flex items-start justify-between">
              <div className="flex gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  1
                </span>
                <Col className="">
                  <span className="text-sm font-bold text-charcoal-900">Truffle Wagyu Burger</span>
                  <span className="mt-1 flex items-center gap-1 text-xs text-charcoal-500">
                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>{' '}
                    Medium Rare
                  </span>
                  <span className="mt-0.5 flex items-center gap-1 text-xs text-brand-red">
                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>{' '}
                    No Onions
                  </span>
                </Col>
              </div>
              <span className="font-mono text-sm font-semibold text-charcoal-900">$24.00</span>
            </div>

            <div className="group flex items-start justify-between">
              <div className="flex gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  2
                </span>
                <Col className="">
                  <span className="text-sm font-bold text-charcoal-900">Signature Lunch Combo</span>
                  <span className="mt-1 border-l-2 border-gray-200 pl-2 text-xs text-charcoal-500">
                    - Classic Ribeye (8oz)
                  </span>
                  <span className="mt-0.5 border-l-2 border-gray-200 pl-2 text-xs text-charcoal-500">
                    - Sweet Potato Fries
                  </span>
                </Col>
              </div>
              <span className="font-mono text-sm font-semibold text-charcoal-900">$25.00</span>
            </div>

            <div className="group flex w-full items-start justify-between">
              <div className="flex flex-1 gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  3
                </span>
                <Col className="flex w-full">
                  <div className="flex justify-between">
                    <span className="text-sm font-bold text-charcoal-900">House Red Wine (Glass)</span>
                    <span className="font-mono text-sm font-semibold text-charcoal-900">$12.00</span>
                  </div>
                  <div className="mt-1 flex justify-between">
                    <span className="flex items-center gap-1 text-fs-md font-medium text-brand-red">
                      <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                        />
                      </svg>{' '}
                      Happy Hour (50%)
                    </span>
                    <span className="font-mono text-fs-md font-semibold text-brand-red">-$6.00</span>
                  </div>
                </Col>
              </div>
            </div>
          </Col>

          <div className="border-t border-gray-200 bg-gray-50 p-5">
            <div className="mb-2 flex justify-between text-sm text-charcoal-600">
              <span>Subtotal</span>
              <span className="font-mono">$61.00</span>
            </div>
            <div className="mb-2 flex justify-between text-sm font-medium text-brand-red">
              <span>Discount</span>
              <span className="font-mono">-$6.00</span>
            </div>
            <div className="mb-4 flex justify-between text-sm text-charcoal-600">
              <span>Tax (8%)</span>
              <span className="font-mono">$4.40</span>
            </div>
            <div className="mb-4 h-px w-full bg-gray-200" />
            <div className="mb-6 flex items-end justify-between">
              <span className="text-sm font-bold uppercase tracking-wide text-charcoal-900">Total</span>
              <span className="font-mono text-3xl font-bold leading-none text-brand-red">$59.40</span>
            </div>

            <div className="flex gap-3">
              <button
                type="button"
                className="w-1/3 rounded-lg border-2 border-gray-300 bg-white py-3.5 text-xs font-bold uppercase tracking-wide text-charcoal-900 transition-colors hover:bg-gray-100"
              >
                Save
              </button>
              <button
                type="button"
                className="w-2/3 rounded-lg bg-brand-red py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-lg transition-all hover:bg-brand-darkRed"
              >
                Send & Pay
              </button>
            </div>
          </div>
        </Col>
      </div>
    </Col>
  )
}
